import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import './style.scss';

import { routeUserToElections } from './utils';

const Home = (props) => {
  const {
    fetchElectionsByAddress,
    history,
    selectedElection,
    selectedRace,
  } = props;

  const [address, setAddress] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  // higher order function for event callback handlers
  const parseInput = callback => e => callback(e.target.value) || setErrorMessage('');

  const onAddressSubmit = () => {
    if (address.length === 0) return setErrorMessage('No address provided');

    return fetchElectionsByAddress(address, (dispatch, state) => {
      routeUserToElections(history.push, dispatch, state);
    });
  };

  const handleClickEnter = e => e.keyCode === 13 && onAddressSubmit();

  // drill down to deepest level if possible
  const navToExploreCandidates = () => {
    if (selectedRace && selectedRace._id) {
      history.push(`/compare-candidates/${selectedRace._id}`);
    } else if (selectedElection && selectedElection._id) {
      history.push(`/elections/${selectedElection._id}`);
    } else {
      history.push('/elections');
    }
  };

  return (
    <div id="home-page-content">
      <div id="intro-copy-container">
        <p>
          MyBallot finds local elections in your city, crawls the Internet for information about your candidates,
          then runs a sentiment analysis algorithm to determine how candidates stand on important issues.
        </p>
      </div>
      <div id="cta-box-container">
        <div id="cta-box-container-content">
          <div className="input-parent-container">
            <h2>Find Your Ballot</h2>
            <div className="input-container">
              <h4 id="address-instructions">Enter your street address</h4>
              <input
                className={errorMessage ? 'error-state' : ''}
                onChange={parseInput(setAddress)}
                onKeyDown={handleClickEnter}
                placeholder="e.g. 9 Maynard Street, Hanover, NH 03755"
                value={address}
              />
              {errorMessage && <p id="error-message">Error: {errorMessage}</p>}
              <button type="submit" onClick={onAddressSubmit}>Find</button>
            </div>
          </div>
        </div>
      </div>
      <div className="separator-line" />
      <div id="bottom-cta-container">
        <button type="button" onClick={() => history.push('/elections')}>
          <div className="cta-box">
            <h4>View Upcoming Elections</h4>
            <p>Enter your street address above to see all the elections on your ballot.</p>
            <p>You can also view all elections <Link to="/elections">here</Link>.</p>
          </div>
        </button>
        <button type="button" onClick={navToExploreCandidates}>
          <div className="cta-box">
            <h4>Explore Candidates</h4>
            <p>Select a race within an election and compare how the candidates stand on important issues.</p>
            <p>Select an election <Link to="/elections">here</Link>.</p>
          </div>
        </button>
        <button type="button" onClick={() => history.push('/quiz')}>
          <div className="cta-box">
            <h4>Take Our Quiz</h4>
            <p>Rank your opinions on key topics, then see how the candidates line up with your views.</p>
            <p>You can also take the quiz for a specific race.</p>
          </div>
        </button>
      </div>
    </div>
  );
};

export default Home;
